import {Breadcrumbs} from "@material-tailwind/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons/faHouse";
import {ItemLink} from "../../footer/Footer";
import {useNavigate} from "react-router-dom";

interface BreadCrumbProps {
    pages: ItemLink[];
}

const BreadCrumb = ({ pages = [] }: BreadCrumbProps) => {
    const navigator = useNavigate();

    const navigateToLink = (link: string|undefined) => {
        if (link == undefined) return;
        navigator(link);
    };

    const getPages = () => {
        return pages.map((page) => (
            <a onClick={() => navigateToLink(page.href)}  className="opacity-60">
                <span>{page.title}</span>
            </a>
        ))
    }

    return (
        <Breadcrumbs placeholder='' key='breadCrumbs'>
            <a onClick={() => navigateToLink("/admin/forms/projects/statistics")} className="opacity-60">
               <FontAwesomeIcon icon={faHouse} />
            </a>
            {getPages()}
        </Breadcrumbs>
    );
}

export default BreadCrumb;